import { Component, Input, OnInit } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-modal-photo-guide',
  templateUrl: './modal-photo-guide.component.html',
  styleUrls: ['./modal-photo-guide.component.scss'],
})
export class ModalPhotoGuideComponent implements OnInit {
  @Input() userId: number;
  @Input() arrayIds: number[];

  public isMobile: boolean = false;

  constructor(
    private modalController: ModalController,
    private platform: Platform
    ) {}

  async ngOnInit() {
    await this.platform.ready();
    if (this.platform.is('mobile')) {
      this.isMobile = true;
    }
  }

  cancel() {
    this.modalController.dismiss();
  }

  validate() {
    this.arrayIds.push(this.userId);
    localStorage.setItem('photoGuide', JSON.stringify(this.arrayIds));
    this.modalController.dismiss();
  }
}
